import { CURRENCY, CURRENCY_SYMBOL, CURRENCY_SYMBOL_HTML } from '../data/Currency';

/**
 * This class assumes that all supported currencies are in major units divisible by 100 minor units.
 */
export class MonetaryValue {
	readonly value: number;
	readonly currency: CURRENCY;

	constructor(value: number, currency: CURRENCY) {
		if (value % 1 !== 0) {
			throw new Error('Value must be an integer');
		}

		this.value = value;
		this.currency = currency;
	}

	splitUnits() {
		return {
			major: Math.floor(Math.abs(this.value) / 100),
			minor: Math.abs(this.value) % 100
		};
	}

	/**
	 *
	 * @example 02
	 */
	formatMinorUnits(): string {
		const { minor } = this.splitUnits();

		let minorStr = '' + minor;

		if (minorStr.length < 2) {
			minorStr = '0' + minorStr;
		}

		return minorStr;
	}

	currencySymbol(): string {
		return CURRENCY_SYMBOL[this.currency];
	}

	currencySymbolHtml(): string {
		return CURRENCY_SYMBOL_HTML[this.currency];
	}

	formatMajorPart() {
		const { major } = this.splitUnits();

		return (this.value < 0 ? '-' : '') + this.currencySymbol() + ' ' + +major;
	}

	format() {
		return this.formatMajorPart() + '.' + this.formatMinorUnits();
	}

	toString() {
		return this.format();
	}
}
